export const pluralize = (num: number, singular: string, plural: string): string => {
  return num === 1 ? `${num} ${singular}` : `${num} ${plural}`
}
